import Login from '../pages/Login'
import Bind from '../pages/Bind'
import Home from '../pages/Home'
import {Navigate} from 'react-router-dom'
import Index from "../pages/Index";
import My from "../pages/My";
import Collect from "../pages/Collect/Detail";
import Detail from "../pages/Collect/Detail";
import {List} from "antd-mobile";
import CollectList from "../pages/Collect/List";
import CollectDetail from "../pages/Collect/Detail";
import DeviceBind from "../pages/DeviceBind";
import WarnDetail from "../pages/Warn/Detail";
import WarnList from "../pages/Warn/List";

export default [
	{
		name:'登录',
		path:'/login',
		element:<Login/>
	},
	{
		name:'账号绑定',
		path:'/bind',
		element:<Bind/>
	},
	{
		path:'/home',
		element:<Home/>,
		children:[
			{
				name:'首页',
				path:'index',
				element:<Index/>
			},
			{
				name:'我的',
				path:'my',
				element:<My/>
			},
			{
				path:'/home',
				element:<Navigate to="/home/index"/>
			}
		]
	},
	{
		name:'信息采集',
		path:'/collect',
		children:[
			{
				name:'信息采集',
				path:'/collect/detail',
				element:<CollectDetail/>
			},
			{
				name:'采集列表',
				path:'/collect/list',
				element:<CollectList/>
			},
			{
				path:'/collect',
				element:<Navigate to="/collect/list"/>
			}
		]
	},
	{
		name:'预警处置',
		path:'/warn',
		children:[
			{
				name:'预警详情',
				path:'/warn/detail',
				element:<WarnDetail/>
			},
			{
				name:'预警列表',
				path:'/warn/list',
				element:<WarnList/>
			},
			{
				path:'/warn',
				element:<Navigate to="/warn/list"/>
			}
		]
	},

	{
		name:'设备绑定',
		path:'/device/bind',
		element:<DeviceBind/>
	},
	{
		path:'/',
		element:<Navigate to="/home"/>
	}
]
